import React from "react";
import {
  createStyles,
  type WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import { useTranslations } from "adapters/i18n";

type TitleProps = { isEditing: boolean } & WithStyles<typeof styles>;

function Title({ classes, isEditing }: TitleProps) {
  const { t } = useTranslations();

  const pageTitle = isEditing ? t("user:edit-user") : t("user:create-new-user");

  return <span className={classes.title}>{pageTitle}</span>;
}

const styles = () =>
  createStyles({
    title: {
      fontFamily: "Roboto",
      fontWeight: 700,
      fontSize: "20px",
      color: "#444444",
      marginBottom: "20px",
    },
  });

export default withStyles(styles)(Title);
